import { Image } from '@vinted/web-ui';
import { STATIC_ASSETS_URL } from 'constants/index';
import { jsx as _jsx } from "react/jsx-runtime";

const ErrorHeader = () => /*#__PURE__*/_jsx("div", {
  className: "l-header",
  children: /*#__PURE__*/_jsx("header", {
    className: "l-header__main",
    children: /*#__PURE__*/_jsx("div", {
      className: "container u-flexbox u-align-items-center u-fill-height",
      children: /*#__PURE__*/_jsx("div", {
        className: "u-flexbox u-align-items-center u-fill-width",
        children: /*#__PURE__*/_jsx("div", {
          className: "l-header__logo",
          children: /*#__PURE__*/_jsx("a", {
            className: "u-block",
            href: "/",
            children: /*#__PURE__*/_jsx("div", {
              className: "l-header__logo-container",
              children: /*#__PURE__*/_jsx(Image, {
                src: "".concat(STATIC_ASSETS_URL, "/assets/web-logo/default/logo.svg"),
                alt: "Vinted Home"
              })
            })
          })
        })
      })
    })
  })
});

export default ErrorHeader;